import { useContext, useEffect, useState } from 'react'
import { getStudentClassResults } from 'api/unit-assessment'
import { BookingContext } from 'contexts/booking'
import { ENCOUNTER_CLASS_RESULT_CONTINUE } from 'utils/constants'

/**
 * When enabled, fetches the student's encounter class result and returns whether
 * the teacher gave "Continue". Returns null while loading / waiting for booking.
 */
const useIsContinueEncounterResult = (enabled: boolean): boolean | null => {
    const booking = useContext(BookingContext)
    const [isContinueResult, setIsContinueResult] = useState<boolean | null>(null)

    useEffect(() => {
        if (!enabled) {
            setIsContinueResult(false)
            return
        }

        if (booking.status !== 'validated') {
            return
        }

        let cancelled = false
        setIsContinueResult(null)

        const studentId = booking.user.id

        void getStudentClassResults(booking.auth, booking.classroomId, studentId)
            .then(data => {
                if (cancelled) return
                const studentResult = data?.results?.find(result => result.studentId === studentId)
                const resultTypeId = studentResult?.contentItemResultTypeId
                const isContinue = resultTypeId === ENCOUNTER_CLASS_RESULT_CONTINUE
                setIsContinueResult(isContinue)
            })
            .catch(error => {
                if (cancelled) return
                console.error('Failed to fetch encounter class result for level completion:', error)
                setIsContinueResult(false)
            })

        return () => {
            cancelled = true
        }
    }, [enabled, booking])

    return isContinueResult
}

export { useIsContinueEncounterResult }
